import React from "react";
import "./ExhibitorsSection.css";

export default function ExhibitorsSection() {
const exhibitors = [
  { name: "ZACHARIAS WINES", url: "https://www.zacharias.com.gr/" },
  { name: "MAD WINES", url: "https://worldofnakis.gr/" },
  { name: "MILIA RIZA", url: "https://www.miliariza.com/" },
  { name: "VERVENIOTI WINERY", url: "https://www.verveniotiwinery.gr/" },
  { name: "ZERVAS WINERY", url: "https://www.facebook.com/profile.php/?id=100063541691994" },
  { name: "ZIDIANAKIS GARAGE WINERY", url: "https://www.instagram.com/zidianakiswinery/" },
  { name: "ΑΜΠΕΛΟΤΕΜΑΧΙΟ 211", url: "https://www.facebook.com/Vineyard211" },
  { name: "ΑΜΠΕΛΩΝΕΣ ΧΑΤΖΗΣΑΒΒΑ", url: "https://www.facebook.com/hatzisavvavineyards/?locale=el_GR" },
  { name: "ΚΤΗΜΑ ΓΚΟΥΜΑ", url: "https://www.instagram.com/ktima_gouma_winery/" },
  { name: "ΚΤΗΜΑ ΡΩΞΑΝΗ ΜΑΤΣΑ", url: "https://www.roxanematsaestate.com/?srsltid=AfmBOoqKO1ZVz86C9W7gi-flxlKSiq9lr4283nIHyzwgLVfxPQh2Fi9z" },
  { name: "ΟΙΝΟΙ ΑΔΑΜ", url: "https://www.instagram.com/winesofadam/" },
  { name: "ΟΙΝΟΠΟΙΕΙΟ ΝΙΚΟΛΟΥ", url: "https://nikolouwinery.gr/en/" },
  { name: "ΟΙΝΟΠΟΙΕΙΟ ΠΑΠΑΝΤΩΝΗ", url: "https://www.papantonis.gr/" },
  { name: "FROANDCO WINES", url: "https://www.instagram.com/froandco.wines/" },
  { name: "ΟΙΝΟΠΟΙΕΙΟ ΣΩΤΗΡΙΟΥ", url: "https://sotiriouwinery.gr/" },
  { name: "ΝΙΚΟΛΟΓΙΑΝΝΗΣ ΟΙΝΟΠΟΙΕΙΟ", url: "https://www.facebook.com/people/Nikologianni-Winery/61550677557381/" },
  { name: "BATSAKI FAMILY WINES", url: "https://www.instagram.com/batsakifamily_wines/" },
  { name: "DAMELI WINES", url: "https://dameli.gr/" },
  { name: "BODEGA CRODIRAS", url: "https://www.krontiraswines.com/" },
  { name: "ΆΩΤΟΝ WINERY", url: "https://aoton.gr/el/%ce%b1%cf%81%cf%87%ce%b9%ce%ba%ce%ae/" },
  { name: "VAIOS GANIS ORGANIC WINES", url: "https://www.ganis.gr/" },
  { name: "PETRAKOPOULOS WINES", url: "https://www.instagram.com/petrakopouloswines/" },
  { name: "ΚΤΗΜΑ ΝΙΚΟΛΑΟΥ", url: "https://www.instagram.com/nikolaouestate/" },
  { name: "ΚΟΝΤΟΣ ΟΙΝΟΤΕΧΝΙΚΗ", url: "https://gkontos.gr/" },
  { name: "ΚΤΗΜΑ ΜΠΟΥΓΙΟΥΡΗ", url: "https://mpougiouris-wines.gr/" },
  { name: "ΟΙΝΟΠΟΙΕΙΟ ΟΙΚΟΓ. ΠΑΠΑΘΑΝΑΣΙΟΥ", url: "https://papathanasiouwines.gr/" },
  { name: "GREECE AND GRAPES", url: "https://www.greeceandgrapes.com/en/" },
  { name: "Θ{έρως} WINES COLLECTIVA", url: "https://theroswines.sumupstore.com/" },
  { name: "ΚΤΗΜΑ ΜΟΥΣΩΝ", url: "https://www.musesestate.com/home" },
  { name: "VIE VIN", url: "https://www.instagram.com/vievin_skg/" },
  { name: "ICHNOS WINES", url: "https://www.instagram.com/ichnos_wines/" },
  { name: "ΟΙΝΟΠΟΙΕΙΟ ΠΑΠΑΓΙΑΝΝΑΚΟΣ", url: "https://papagiannakos.gr/" },
  { name: "OENOPS WINES", url: "https://oenopswines.gr/" },
  { name: "ΚΤΗΜΑ ΚΟΝΤΟΒΡΑΚΗ", url: "https://ktimakontovraki.gr/our-wines/" },
  { name: "ΚΤΗΜΑ ΑΠΟΣΤΟΛΙΔΗ", url: "https://domaineapostolidi.gr/wines" },
  { name: "CULTURA", url: "https://www.cultura.com.gr/maintenance" },

  { name: "ΑΜΠΕΛΩΝΕΣ ΜΑΡΚΟΥ", url: "https://ampelonesmarkougroup.gr/oinopoieio/" },
  { name: "GAIA WINES", url: "https://gaiawines.gr/en/" },
  { name: "SELLAS WINERY", url: "https://sellaswinery.gr/" },
  { name: "ΚΤΗΜΑ ΜΗΤΡΑΒΕΛΑ", url: "https://www.mitravelas.gr/en/" },
  { name: "AIOLOS WINES", url: "https://www.aioloswines.gr/" },
  { name: "ΚΤΗΜΑ ΑΝΑΣΤΑΣΙΟΥ", url: "https://ktimaanastasiou.gr/gr/pages/oi-ampelones" },
  { name: "ΟΙΝΟΠΟΙΕΙΟ ΓΚΙΚΑΣ", url: "https://www.gikaswinery.gr/el/" },
  { name: "ΚΤΗΜΑ ΣΤΡΟΦΙΛΙΑ", url: "https://www.strofiliawines.gr/" },


  { name: "OINOVERSE", url: "https://oinoverse.gr/" },
  { name: "TERRA AMPELI", url: "https://www.instagram.com/terraampeli?igsh=MTV1a2N5YWZ2MzQ4bg%3D%3D" },
  { name: "ΣΜΥΡΟΓΛΟΥ ΚΟΣΜΗΜΑΤΑ", url: "https://www.instagram.com/finewinejewellery/" },
  { name: "LUV N ROLL", url: "https://luvnroll.com/" },
];
  return (
    <section id="section4" className="exhibitors-section">
      <div className="exhibitors-container">
        <h2>Exhibitors</h2>
<p className="exhibitors-list">
  {exhibitors.map((exhibitor, index) => (
    <React.Fragment key={index}>
      <a href={exhibitor.url} target="_blank" rel="noopener noreferrer">
        {exhibitor.name}
      </a>
      {index < exhibitors.length - 1 && <span className="divider"> | </span>}
    </React.Fragment>
  ))}
</p>

      </div>
    </section>
  );
}
